import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchRecipesState } from "../../../interfaces/store/recipes-interface";
import { CARDS_PAGE_SIZE } from "../../../common/config";

const initialState: IFetchRecipesState = {
  recipes: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: CARDS_PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchRecipesStart = (
  state: IFetchRecipesState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchRecipesSuccess = (
  state: IFetchRecipesState,
  { payload }: PayloadAction<any>
) => {
  state.recipes = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchRecipesFailed = (
  state: IFetchRecipesState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetRecipes = () => {
  return { ...initialState };
};

const RecipesSlice = createSlice({
  name: "recipes",
  initialState,
  reducers: {
    fetchRecipesStart: _fetchRecipesStart,
    fetchRecipesSuccess: _fetchRecipesSuccess,
    fetchRecipesFailed: _fetchRecipesFailed,
    resetRecipes: _resetRecipes,
  },
});

export const {
  fetchRecipesStart,
  fetchRecipesSuccess,
  fetchRecipesFailed,
  resetRecipes,
} = RecipesSlice.actions;
export default RecipesSlice.reducer;
